export const SET_SKETCH_BACKGROUND_IMG_SUCCESS =
    "SET_SKETCH_BACKGROUND_IMG_SUCCESS";
export const EDIT_SKETCH_BACKGROUND_IMG_SUCCESS =
    "EDIT_SKETCH_BACKGROUND_IMG_SUCCESS";
